import { onMounted, reactive } from 'vue'
import router from '@/router'

export function useQueryParams() {
  const queryParams = reactive<Record<string, string>>({})

  onMounted(() => {
    setQueryParam(router.currentRoute.value.query as Record<string, string>)
  })

  function setQueryParam(params: Record<string, string | undefined>) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        queryParams[key] = value
      } else {
        delete queryParams[key]
      }
    })
    router.replace({
      path: router.currentRoute.value.path,
      query: queryParams
    })
  }

  return { setQueryParam, queryParams }
}
